import styled from 'styled-components'

export const Container = styled.div`
   margin-top: 30px;
   margin-left: 30px;
   margin-right: 30px;
`
